/**
 * Pull a human-readable message out of an axios-style API error, with a
 * sensible fallback.
 *
 * The backend returns failures as `{ message: string }` with a real 4xx/5xx
 * status (no raw `error` field). Use this in mutation `onError` handlers so the
 * server's message (e.g. a 409 conflict or 429 rate-limit reason) reaches the
 * user instead of a flat generic title.
 */
export function errorMessage(e: unknown, fallback: string): string {
  const msg = (e as { response?: { data?: { message?: string } } })?.response?.data?.message;
  return msg || fallback;
}
